import React from 'react';
import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { RESIDUE_WAREHOUSE_GUIDE_REGISTER_PATH } from '../legacy/constants';


const Section = (props) => {
    return (
        <React.Fragment>
            <Row className="mb-3 pb-1">
                <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                        <div className="flex-grow-1">
                        </div>
                        <div className="mt-3 mt-lg-0">
                            <form action="#">
                                <Row className="g-3 mb-0 align-items-center">
                                    
                                    <div className="col-auto">
                                        <Link
                                            to={RESIDUE_WAREHOUSE_GUIDE_REGISTER_PATH}
                                            className="nav-link"
                                            data-key="t-basic-action"
                                        >
                                            <button type="button" className="btn btn-label btn-primary">
                                                <i className="ri-add-line label-icon"></i> Generar guía
                                            </button>
                                        </Link>
                                    </div>
                                    <div className="col-auto">
                                        <button
                                            type="button"
                                            className="btn btn-label btn-primary"
                                            onClick={props.rightCanvasBtn} // Added onClick event handler here
                                        >
                                            <i className="ri-filter-fill label-icon"></i> Filtros
                                        </button>
                                    </div>
                                </Row>
                            </form>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default Section;